export default {
    LOADiNG_TITLE: "Идет загрузка",
    LOADING_DESCRIPTION: "Пожалуйста, подождите",
    CANCEL: "Отмена"
};
